import { Component } from "@angular/core";
import { FilesService } from "app/shared/services/files.service";

@Component({
    selector: 'download-import-template',
    template: `
    <div class="flex-row">
        <button 
            (click)="downloadTemplate()" 
            class="icon-button flex-row" 
            tabindex="0"
            title="Download template"
        >
            <div class="icon-button__cover"></div>
            <div class="action">
                <clr-icon shape="download" size="24" class="ng-star-inserted"></clr-icon>
            </div>
        </button>
    </div>
    `,
})

export class DownloadImportTemplateComponent {
    private fileName = 'userimport_template_v1.xlsx';

    constructor(private fileService: FilesService) {}

    downloadTemplate(): void {
      this.fileService.downloadFile(this.fileName).subscribe((data: Blob) => {
        // MIME type: Excel spreadsheet
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.fileName;
        link.click();
      });
    }
}